/// <reference types="node" />
// In production (Docker), REACT_APP_API_URL is set to "" so all paths are relative
// and nginx proxies /api and /static to the backend.  In local dev it falls back
// to "" as well — the React dev server proxy (set in package.json) forwards /api
export const API_URL = process.env.REACT_APP_API_URL ?? '';

export class ApiError extends Error {
   readonly status: number;
   readonly detail: string;

   constructor(status: number, statusText: string, detail: string) {
      super(detail || `Request failed: ${status} ${statusText}`);
      this.name = 'ApiError';
      this.status = status;
      this.detail = detail;
   }
}

/**
 * Typed wrapper around `fetch` that:
 * - Prepends `API_URL` to the path so the same call works in both dev and
 *   production Docker deployments.
 * - Sends cookies (`credentials: 'include'`) for session-based API routes.
 * - Throws `ApiError` on non-2xx HTTP responses.
 * - Deserialises the response body as JSON and returns it cast to `T`.
 */
export async function apiFetch<T>(path: string, options: RequestInit = {}): Promise<T> {
   const response = await fetch(`${API_URL}${path}`, { credentials: 'include', ...options });
   if (!response.ok) {
      let detail = '';
      try {
         const body = (await response.json()) as { detail?: unknown };
         if (typeof body.detail === 'string') detail = body.detail;
         else if (body.detail != null) detail = JSON.stringify(body.detail);
      } catch {
         detail = '';
      }
      throw new ApiError(response.status, response.statusText, detail);
   }
   return response.json() as Promise<T>;
}
